import React, { Component } from 'react';
import queryString from 'query-string';
import { Link } from "react-router-dom";

export class Campaign extends Component {
    constructor(props) {
        super(props);
        this.state = { campaign: null, loading: true, facilityId: "", receiverSuffix: "", assetId: "", versionId: "", mediaId: "", diags: false };

        this.updateFacilityId = this.updateFacilityId.bind(this);
        this.updateReceiverSuffix = this.updateReceiverSuffix.bind(this);
        this.updateAssetId = this.updateAssetId.bind(this);
        this.updateVersionId = this.updateVersionId.bind(this);
        this.updateMediaId = this.updateMediaId.bind(this);
        this.updateUrl = this.updateUrl.bind(this);
    }

    componentDidMount() {
        console.log("mount");

        this.fetchCampaign(this.props.id);
    }

    componentDidUpdate() {
        console.log("update");

        var qs = queryString.parse(window.location.search);
        var diags = qs["diags"];

        if (!diags && !this.props.hide && this.state.campaign)        
            window.location.href = this.state.campaign.destinationUrl;
    }

    updateFacilityId(event) {
        this.setState({ facilityId: event.target.value })
    }

    updateReceiverSuffix(event) {
        this.setState({ receiverSuffix: event.target.value })
    }

    updateAssetId(event) {
        this.setState({ assetId: event.target.value })
    }

    updateVersionId(event) {
        this.setState({ versionId: event.target.value })
    }

    updateMediaId(event) {
        this.setState({ mediaId: event.target.value })
    }

    appendToUrl(url, name, value) {
        if (value) {
            if (url.indexOf("?") < 0)
                url += "?";
            else
                url += "&";

            url += name + "=" + value;
        }

        return url;
    }

    computeUrl(base, campaignId, facilityId, receiverSuffix, assetId, versionId, mediaId, diags) {
        var url = base + "/" + campaignId;

        url = this.appendToUrl(url, "facilityId", facilityId);
        url = this.appendToUrl(url, "receiverSuffix", receiverSuffix);
        url = this.appendToUrl(url, "assetId", assetId);
        url = this.appendToUrl(url, "versionId", versionId);
        url = this.appendToUrl(url, "mediaId", mediaId);
        url = this.appendToUrl(url, "diags", diags);

        return url;
    }

    updateUrl(event) {
        event.preventDefault();
        this.props.history.push(this.computeUrl("/campaign", this.state.campaign.id, this.state.facilityId, this.state.receiverSuffix, this.state.assetId, this.state.versionId, this.state.mediaId, this.state.diags));
        this.fetchCampaign(this.state.campaign.id);
    }

    renderCampaign(campaign, diags) {
        return (
            <div>
                <ul className="nav nav-tabs">
                    <li className="nav-item">
                        <a id="user-tab" className={"nav-link" + (!diags ? " active" : "")} href={this.computeUrl("/campaign", this.state.campaign.id, this.state.facilityId, this.state.receiverSuffix, this.state.assetId, this.state.versionId, this.state.mediaId)}>User</a>
                    </li>
                    <li className="nav-item">
                        <Link id="diags-tab" className={"nav-link" + (diags ? " active" : "")} to={this.computeUrl("/campaign", this.state.campaign.id, this.state.facilityId, this.state.receiverSuffix, this.state.assetId, this.state.versionId, this.state.mediaId, "true")}>Diags</Link>
                    </li>
                </ul>

                <div className="tab-content">
                    {!diags ?
                        <div className="tab-pane fade show active" id="user" role="tabpanel" aria-labelledby="user-tab">
                            <h2>What the End-User Sees</h2>

                            <h3>Consent Stuff</h3>
                            <p>Not doing this for now.</p>

                            <h3>Redirect</h3>

                            As soon as we fire our reporting call, we'll forward you to your <a href={campaign.destinationUrl}>destination</a>!
                        </div> :
                        <div className="tab-pane fade show active" id="diags" role="tabpanel" aria-labelledby="diags-tab">
                            <h2>Campaign Attributes</h2>

                            <table className='table table-striped'>
                                <tbody>
                                    <tr key="id"><th>Id</th><td>{campaign.id}</td></tr>
                                    <tr key="name"><th>Name</th><td>{campaign.name}</td></tr>
                                    <tr key="description"><th>Description</th><td>{campaign.description}</td></tr>
                                    <tr key="destinationUrlTemplate"><th>Destination Url Template</th><td>{campaign.destinationUrlTemplate}</td></tr>
                                    <tr key="codePrefix"><th>Code Prefix</th><td>{campaign.codePrefix}</td></tr>
                                    <tr key="mediaId"><th>CTA Media Ids</th><td>{campaign.mediaIds.join(", ")}</td></tr>
                                    <tr key="mediaUrl"><th>First CTA Media URL</th><td><a target="_blank" href={campaign.mediaUrl}>{campaign.mediaUrl}</a></td></tr>
                                    <tr key="media"><th>First CTA Media</th><td><img width="800px" style={{ backgroundColor: "#dee2e6", maxWidth: "100%" }} src={campaign.mediaUrl} /></td></tr>
                                </tbody>
                            </table>

                            <h2>Clickthrough Url Parameters</h2>

                            <form style={{ display: "flex", alignItems: "flex-end", flexWrap: "wrap", margin: "0 0 2rem 0" }}>
                                <div style={{ display: "flex", alignItems: "center", margin: "1rem 0" }}>
                                    <div className="form-group" style={{ maxWidth: "200px", margin: "0 2rem 0 0" }}>
                                        <label htmlFor="facilityId">Facility Id</label>
                                        <input type="text" className="form-control" id="facilityId" placeholder="Enter Facility Id" onChange={this.updateFacilityId} value={this.state.facilityId} />
                                    </div>
                                    <div className="form-group" style={{ maxWidth: "200px", margin: "0 2rem 0 0" }}>
                                        <label htmlFor="receiverSuffix">Receiver Suffix</label>
                                        <input type="text" className="form-control" id="receiverSuffix" placeholder="Enter Receiver Suffix" onChange={this.updateReceiverSuffix} value={this.state.receiverSuffix} />
                                    </div>
                                    <div className="form-group" style={{ maxWidth: "200px", margin: "0 2rem 0 0" }}>
                                        <label htmlFor="assetId">Asset Id</label>
                                        <input type="text" className="form-control" id="assetId" placeholder="Enter Asset Id" onChange={this.updateAssetId} value={this.state.assetId} />
                                    </div>
                                    <div className="form-group" style={{ maxWidth: "200px", margin: "0 2rem 0 0" }}>
                                        <label htmlFor="versionId">Version Id</label>
                                        <input type="text" className="form-control" id="versionId" placeholder="Enter Version Id" onChange={this.updateVersionId} value={this.state.versionId} />
                                    </div>
                                    <div className="form-group" style={{ maxWidth: "200px", margin: "0 2rem 0 0" }}>
                                        <label htmlFor="mediaId">Media Id</label>
                                        <input type="text" className="form-control" id="mediaId" placeholder="Enter Media Id" onChange={this.updateMediaId} value={this.state.mediaId} />
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-primary" onClick={this.updateUrl}>Update</button>
                            </form>

                            <h2>Generated Destination Url</h2>

                            <table className='table table-striped'>
                                <tbody>
                                    <tr key="url"><th>Destination Url</th><td><a target="_blank" href={campaign.destinationUrl}>{campaign.destinationUrl}</a></td></tr>
                                </tbody>
                            </table>
                        </div>
                    }
                </div>
            </div>
        );
    }

    render() {
        var qs = queryString.parse(window.location.search);
        var diags = qs["diags"];

        var hide = this.props.hide;

        if (this.state.loading && (!diags || !hide))
            return "Loading...";

        if (this.state.loading || !diags)
            return null;

        return (
            <div>
                <h1>{this.state.campaign.name}</h1>
                {this.renderCampaign(this.state.campaign, true)}
            </div>
        );
    }

    async fetchCampaign(id) {
        console.log("fetch");
        var qs = queryString.parse(window.location.search);

        var facilityId = qs["facilityId"] || qs["f"];
        var receiverSuffix = qs["receiverSuffix"] || qs["r"];
        var assetId = qs["assetId"] || qs["a"];
        var versionId = qs["versionId"] || qs["v"];
        var mediaId = qs["mediaId"] || qs["m"];
        var diags = qs["diags"];

        const response = await fetch(this.computeUrl("/api/campaign", id, facilityId, receiverSuffix, assetId, versionId, mediaId, diags));
        const data = await response.json();

        this.setState({ campaign: data, loading: false, facilityId: facilityId || "", receiverSuffix: receiverSuffix || "", assetId: assetId || "", versionId: versionId || "", mediaId: mediaId || "", diags: diags });
    }
}
